import { useMutation } from '@tanstack/react-query';

import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';
import { CreateActivityModel } from '../../../../../features/activities/editActivity/editActivityForm/schema/editActivitySchema';
import { UpdateActivityReportingRequirementsModel } from '../../../../../features/activities/editActivity/editReportingRequirements/types';
import { ActivityNewEditResponse } from './types';

export function useNewActivityMutation() {
  return useMutation({
    mutationFn: async (model: NewActivityRequest) =>
      await getAxios().post<ActivityNewEditResponse>(ActivityEndpoints.edit.post(), model)
  });
}

type NewActivityRequest = {
  ActivityModel: Partial<CreateActivityModel>;
  ReportingRequirementsModel: Partial<UpdateActivityReportingRequirementsModel>;
};
